import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  phone:'',
	  permission:0,
	  username:'',
	  is_out_user:false,   // 内部用户：false  外部用户：true
	  is_achievement_actived:false, 
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
